/**
 * VIOSSI "Sharp Retail" — product page (PDP) behaviour.
 *
 * Progressive enhancement: the page is fully functional without this file
 * (native <select> variant picker, native <details> accordions, form POSTs to
 * /cart). This script layers on the gallery zoom/lightbox, the custom size
 * dropdown, live variant state, the sticky add-to-cart bar and AJAX add-to-cart
 * that hands the updated cart to the drawer via a `cart:updated` event.
 *
 * Written plain (no Liquid) so it lives in assets/ and is served with `defer`.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var money = root.getAttribute('data-money-format') || '${{amount}}';

  function stripTags(str) {
    // Shopify money_format can carry HTML (e.g. <span class=money>$1</span>).
    // When it lands in a text node that markup must be stripped, not shown raw.
    return String(str).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
  }

  function formatMoney(cents) {
    // Полный набор плейсхолдеров money_format (как в cart.js): усечённая
    // версия знала только {{amount}} — EUR-рынки с
    // {{amount_with_comma_separator}} получали сырой шаблон на кнопке ATC.
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      /* как money_without_trailing_zeros на сервере: «$399», но «$399.50» */
      if (/^\D0+$/.test(cents2)) cents2 = '';
      return dollars + cents2;
    }

    var match = money.match(placeholder);
    if (!match) return stripTags(money);
    var value = '';
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return stripTags(money.replace(placeholder, value));
  }

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  /* ------------------------------------------------------------------ *
   * Gallery: thumbnail selection + main-image swap
   * ------------------------------------------------------------------ */
  var mainImg = $('#pdpMainImg');
  var thumbs = $$('.pdp-thumb');
  var thumbsBox = $('.pdp-thumbs');

  if (mainImg) {
    mainImg.addEventListener('load', function () {
      mainImg.classList.remove('is-swapping');
    });
  }

  /* Keep the active thumb visible inside the (scrollable) thumbs strip —
     scroll the strip itself, never the page. */
  function revealThumb(btn) {
    if (!thumbsBox || !btn) return;
    var vertical = getComputedStyle(thumbsBox).flexDirection.indexOf('column') === 0;
    if (vertical) {
      var top = btn.offsetTop - (thumbsBox.clientHeight - btn.offsetHeight) / 2;
      thumbsBox.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } else {
      var left = btn.offsetLeft - (thumbsBox.clientWidth - btn.offsetWidth) / 2;
      thumbsBox.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
  }

  function selectThumb(index) {
    thumbs.forEach(function (t) {
      var on = Number(t.getAttribute('data-thumb-index')) === index;
      t.classList.toggle('on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var active = thumbs.filter(function (t) {
      return Number(t.getAttribute('data-thumb-index')) === index;
    })[0];
    if (active && mainImg) {
      var full = active.getAttribute('data-full');
      var srcset = active.getAttribute('data-srcset');
      mainImg.classList.add('is-swapping');
      if (srcset) mainImg.setAttribute('srcset', srcset); else mainImg.removeAttribute('srcset');
      if (full) mainImg.src = full;
      mainImg.alt = active.getAttribute('data-alt') || mainImg.alt;
      if (mainImg.complete && mainImg.naturalWidth) mainImg.classList.remove('is-swapping');
      revealThumb(active);
    }
    galleryIndex = index;
    /* Открытый лайтбокс листается вместе с галереей: доводим scroll-snap
       трек до слайда с этим индексом (если он уже не там). */
    if (lightbox && lightbox.open && lbTrack) {
      var left = index * lbTrack.clientWidth;
      if (Math.abs(lbTrack.scrollLeft - left) > 8) {
        lbTrack.scrollTo({ left: left, behavior: prefersReduced ? 'auto' : 'smooth' });
      }
    }
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      selectThumb(Number(t.getAttribute('data-thumb-index')));
    });
  });

  /* ------------------------------------------------------------------ *
   * Свайп по фото (мобила): главное фото и лайтбокс листаются влево-вправо.
   * Порог 44px и перевес горизонтали ×1.5 — чтобы не воровать вертикальный
   * скролл страницы; passive-слушатели, скролл не блокируем.
   * ------------------------------------------------------------------ */
  var galleryIndex = 0;
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function stepGallery(delta) {
    if (thumbs.length < 2) return;
    var next = (galleryIndex + delta + thumbs.length) % thumbs.length;
    selectThumb(next);
  }

  /* Направленный слайд при листании: текущее фото уезжает в сторону свайпа,
     новое въезжает с противоположной. Инлайн-стили в конце снимаются, чтобы
     не мешать hover-зуму (он живёт на CSS-transform). */
  function slideStep(img, delta) {
    if (!img || prefersReduced) { stepGallery(delta); return; }
    var dir = delta > 0 ? 1 : -1;
    img.style.transition = 'transform 0.16s ease, opacity 0.16s ease';
    img.style.transform = 'translateX(' + -22 * dir + 'px)';
    img.style.opacity = '0.3';
    window.setTimeout(function () {
      stepGallery(delta);
      img.style.transition = 'none';
      img.style.transform = 'translateX(' + 22 * dir + 'px)';
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          img.style.transition = 'transform 0.2s ease, opacity 0.2s ease';
          img.style.transform = '';
          img.style.opacity = '';
          window.setTimeout(function () { img.style.transition = ''; }, 220);
        });
      });
    }, 150);
  }

  function bindSwipe(el, onLeft, onRight) {
    var sx = 0;
    var sy = 0;
    var tracking = false;
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { tracking = false; return; }
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) onLeft(); else onRight();
      }
    }, { passive: true });
  }

  /* Warm the browser cache for every gallery image after the page is done
     loading, so switching photos is instant instead of a multi-second fetch.
     srcset+sizes mirror the main image so the browser prefetches exactly the
     candidate it will pick on swap. */
  function prefetchGallery() {
    var sizes = mainImg ? mainImg.getAttribute('sizes') || '' : '';
    thumbs.forEach(function (t) {
      var srcset = t.getAttribute('data-srcset');
      var img = new Image();
      if (srcset && 'sizes' in img) {
        img.sizes = sizes;
        img.srcset = srcset;
      } else if (t.getAttribute('data-full')) {
        img.src = t.getAttribute('data-full');
      }
    });
  }
  if (thumbs.length) {
    var startPrefetch = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(prefetchGallery, { timeout: 4000 });
      else setTimeout(prefetchGallery, 1500);
    };
    if (document.readyState === 'complete') startPrefetch();
    else window.addEventListener('load', startPrefetch);
  }

  /* ------------------------------------------------------------------ *
   * Gallery: hover zoom (fine pointers only) + click/keyboard lightbox
   * ------------------------------------------------------------------ */
  var main = $('#pdpMain');
  var lightbox = $('#pdpLightbox');
  var lbTrack = lightbox ? lightbox.querySelector('.pdp-lb-track') : null;
  var lbSlideCount = lbTrack ? lbTrack.children.length : 0;
  var finePointer = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

  if (main && finePointer) {
    main.addEventListener('mouseenter', function () { main.classList.add('is-zoom'); });
    main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
    main.addEventListener('mousemove', function (e) {
      if (!main.classList.contains('is-zoom')) return;
      var r = main.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      if (mainImg) mainImg.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  /* Индекс слайда, на котором сейчас стоит (или почти стоит) трек. */
  function lbIndexFromScroll() {
    if (!lbTrack) return 0;
    var w = lbTrack.clientWidth || 1;
    return Math.max(0, Math.min(lbSlideCount - 1, Math.round(lbTrack.scrollLeft / w)));
  }

  function openLightbox() {
    if (!lightbox || !lbTrack || !lbSlideCount) return;
    if (main) main.classList.remove('is-zoom');
    if (typeof lightbox.showModal === 'function') lightbox.showModal();
    else lightbox.setAttribute('open', '');
    /* Сразу встаём на текущее фото галереи — без видимой прокрутки. */
    lbTrack.scrollTo({ left: galleryIndex * lbTrack.clientWidth, behavior: 'auto' });
  }

  if (main) {
    main.addEventListener('click', openLightbox);
    main.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); slideStep(mainImg, 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); slideStep(mainImg, -1); }
    });
    bindSwipe(main, function () { slideStep(mainImg, 1); }, function () { slideStep(mainImg, -1); });
  }
  if (lightbox) {
    $$('[data-lightbox-close]', lightbox).forEach(function (b) {
      b.addEventListener('click', function () { lightbox.close(); });
    });
    /* Тап мимо фото (трек/поля слайда) закрывает, как раньше клик по backdrop. */
    lightbox.addEventListener('click', function (e) {
      var t = e.target;
      if (t === lightbox || t === lbTrack || (t.classList && t.classList.contains('pdp-lb-slide'))) {
        lightbox.close();
      }
    });
    /* Стрелки листают трек; в лайтбоксе без закольцовки — как в нативных
       галереях. Esc и фокус держит сам <dialog>. */
    lightbox.addEventListener('keydown', function (e) {
      var delta = 0;
      if (e.key === 'ArrowRight') delta = 1;
      else if (e.key === 'ArrowLeft') delta = -1;
      if (!delta || lbSlideCount < 2) return;
      e.preventDefault();
      var idx = lbIndexFromScroll();
      var next = Math.max(0, Math.min(lbSlideCount - 1, idx + delta));
      if (next !== idx) selectThumb(next);
    });
  }

  if (lbTrack) {
    /* Горизонтальный свайп — чистый CSS scroll-snap; JS лишь дожидается
       остановки и синхронизирует главную галерею/тамбы с новым слайдом. */
    var lbSettleTimer = 0;
    var onLbSettle = function () {
      if (!lightbox || !lightbox.open) return;
      var idx = lbIndexFromScroll();
      if (idx !== galleryIndex) selectThumb(idx);
    };
    if ('onscrollend' in window) {
      lbTrack.addEventListener('scrollend', onLbSettle);
    } else {
      lbTrack.addEventListener('scroll', function () {
        window.clearTimeout(lbSettleTimer);
        lbSettleTimer = window.setTimeout(onLbSettle, 140);
      }, { passive: true });
    }

    /* Свайп вниз закрывает. Вертикального скролла у трека нет (горизонталь
       разруливает scroll-snap), так что жест ни с чем не конфликтует. */
    var lbSwipeY = 0;
    var lbSwipeX = 0;
    var lbSwipeOn = false;
    lbTrack.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { lbSwipeOn = false; return; }
      lbSwipeX = e.touches[0].clientX;
      lbSwipeY = e.touches[0].clientY;
      lbSwipeOn = true;
    }, { passive: true });
    lbTrack.addEventListener('touchend', function (e) {
      if (!lbSwipeOn) return;
      lbSwipeOn = false;
      var t = e.changedTouches && e.changedTouches[0];
      if (!t || !lightbox) return;
      var dx = t.clientX - lbSwipeX;
      var dy = t.clientY - lbSwipeY;
      if (dy > 70 && dy > Math.abs(dx) * 1.5) lightbox.close();
    }, { passive: true });
  }

  /* ------------------------------------------------------------------ *
   * Variant state — driven by the native <select name="id">
   * ------------------------------------------------------------------ */
  var form = $('#pdpForm');
  var select = $('#pdpVariantSelect');
  var atcBtn = $('#pdpAtc');
  var atcLabel = $('#pdpAtcLabel');
  var priceNow = $('#pdpPriceNow');

  function selectedOption() {
    return select && select.options[select.selectedIndex];
  }

  function syncVariantState() {
    var opt = selectedOption();
    if (!opt) return;
    var available = opt.getAttribute('data-available') === 'true';
    var price = Number(opt.getAttribute('data-price'));
    var hasSize = opt.value !== '';

    if (atcBtn) {
      atcBtn.disabled = !available || !hasSize;
    }
    if (atcLabel) {
      if (!hasSize) atcLabel.textContent = atcLabel.getAttribute('data-select-text') || 'Select a size';
      else if (!available) atcLabel.textContent = atcLabel.getAttribute('data-soldout-text') || 'Sold out';
      else atcLabel.textContent = (atcLabel.getAttribute('data-add-text') || 'Add to Bag') + ' · ' + formatMoney(price);
    }
    // SKU line follows the chosen size; hidden when the variant has none
    var skuLine = $('#pdpSku');
    if (skuLine) {
      var sku = hasSize ? (opt.getAttribute('data-sku') || '') : '';
      var skuVal = $('#pdpSkuVal');
      if (skuVal) skuVal.textContent = sku;
      skuLine.hidden = !sku;
    }
    // mirror to sticky bar
    var stickySelect = $('#pdpStickySelect');
    if (stickySelect && stickySelect.value !== opt.value) stickySelect.value = opt.value;
    // mirror to custom dropdown label
    var ddVal = $('.sizedd-val');
    if (ddVal && hasSize) ddVal.textContent = opt.getAttribute('data-label') || opt.textContent;
    // refresh the honest urgency line for the chosen size
    renderUrgency(hasSize ? opt.value : '');
    // cap the stepper at what this exact size actually has in stock
    applyQtyMax(hasSize ? opt.value : '');
  }

  if (select) select.addEventListener('change', syncVariantState);

  /* ------------------------------------------------------------------ *
   * Custom size dropdown (enhances the native <select>)
   * ------------------------------------------------------------------ */
  var dd = $('.sizedd');
  var nativeWrap = $('.pdp-native-size');

  if (dd && select) {
    dd.hidden = false;
    if (nativeWrap) nativeWrap.classList.add('is-enhanced');

    var ddBtn = $('.sizedd-btn', dd);
    var options = $$('.sd-opt', dd);

    function closeDD() {
      dd.classList.remove('open');
      if (ddBtn) ddBtn.setAttribute('aria-expanded', 'false');
    }
    function openDD() {
      dd.classList.add('open');
      if (ddBtn) ddBtn.setAttribute('aria-expanded', 'true');
      var r = ddBtn.getBoundingClientRect();
      dd.classList.toggle('up', (window.innerHeight - r.bottom) < 300 && r.top > 320);
    }
    function chooseValue(value, label) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      options.forEach(function (o) { o.classList.toggle('sel', o.getAttribute('data-value') === value); });
      var val = $('.sizedd-val', dd);
      if (val) val.textContent = label;
      closeDD();
      if (ddBtn) ddBtn.focus();
    }

    if (ddBtn) {
      ddBtn.addEventListener('click', function () {
        dd.classList.contains('open') ? closeDD() : openDD();
      });
      ddBtn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openDD();
          var first = options.filter(function (o) { return !o.hasAttribute('disabled'); })[0];
          if (first) first.focus();
        }
      });
    }

    options.forEach(function (o) {
      if (o.hasAttribute('disabled')) return;
      o.addEventListener('click', function () {
        chooseValue(o.getAttribute('data-value'), o.getAttribute('data-label'));
      });
      o.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          chooseValue(o.getAttribute('data-value'), o.getAttribute('data-label'));
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var enabled = options.filter(function (x) { return !x.hasAttribute('disabled'); });
          var i = enabled.indexOf(o);
          var next = e.key === 'ArrowDown' ? enabled[i + 1] : enabled[i - 1];
          if (next) next.focus();
        } else if (e.key === 'Escape') {
          closeDD();
          if (ddBtn) ddBtn.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.sizedd')) closeDD();
    });
  }

  /* ------------------------------------------------------------------ *
   * Quantity stepper — capped at the variant's real, tracked stock
   *
   * The Liquid map (`[data-pdp-inventory]`) lists only variants Shopify both
   * tracks and refuses to oversell, so a missing variant genuinely has no
   * ceiling and gets no `max`. Every path into the value — the +/− buttons,
   * typing into the input, switching size — funnels through setQty(), which
   * is the single place the clamp lives.
   * ------------------------------------------------------------------ */
  var qtyInput = $('#pdpQty');
  var qtyView = $('#pdpQtyView');
  var qtyMax = 0; /* 0 = no ceiling (untracked stock or oversell allowed) */

  var inventoryMap = null;
  var inventoryScript = root.querySelector('[data-pdp-inventory]');
  if (inventoryScript) {
    try {
      inventoryMap = JSON.parse(inventoryScript.textContent || '{}');
    } catch (err) {
      inventoryMap = null;
    }
  }

  function setQty(n) {
    if (isNaN(n)) n = 1;
    n = Math.max(1, n);
    if (qtyMax > 0) n = Math.min(qtyMax, n);
    if (qtyInput) qtyInput.value = n;
    if (qtyView) qtyView.textContent = n;
    if (plus) {
      var atCap = qtyMax > 0 && n >= qtyMax;
      plus.setAttribute('aria-disabled', atCap ? 'true' : 'false');
    }
  }

  /* Called on every variant change: repoint the ceiling, then re-run the
     clamp so a quantity picked for a roomier size drops to the new stock. */
  function applyQtyMax(variantId) {
    var cap = 0;
    if (inventoryMap && variantId && Object.prototype.hasOwnProperty.call(inventoryMap, variantId)) {
      cap = parseInt(inventoryMap[variantId], 10) || 0;
    }
    qtyMax = cap > 0 ? cap : 0;
    if (qtyInput) {
      if (qtyMax > 0) qtyInput.setAttribute('max', qtyMax);
      else qtyInput.removeAttribute('max');
    }
    setQty(parseInt(qtyInput && qtyInput.value, 10) || 1);
  }

  var minus = $('#pdpQtyMinus');
  var plus = $('#pdpQtyPlus');
  if (minus) minus.addEventListener('click', function () { setQty(Number(qtyInput.value || 1) - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(Number(qtyInput.value || 1) + 1); });
  if (qtyInput) {
    /* Typed values are only corrected once the shopper is done: clamping on
       every keystroke fights the caret while a two-digit number is typed. */
    qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });
    qtyInput.addEventListener('blur', function () { setQty(parseInt(qtyInput.value, 10)); });
  }

  /* ------------------------------------------------------------------ *
   * Size guide modal — lazy-load the iframe on first open
   * ------------------------------------------------------------------ */
  var sizeGuide = $('#pdpSizeGuide');
  var sizeGuideLoader = sizeGuide ? $('[data-size-guide-loader]', sizeGuide) : null;
  var sizeGuideFrame = sizeGuide ? $('#pdpSizeGuideFrame', sizeGuide) : null;
  function hideSizeGuideLoader() {
    if (sizeGuideLoader) sizeGuideLoader.classList.add('is-done');
  }
  if (sizeGuideFrame) {
    sizeGuideFrame.addEventListener('load', function () {
      if (sizeGuideFrame.getAttribute('src')) hideSizeGuideLoader();
    });
  }
  $$('[data-size-guide-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      if (!sizeGuide) return;
      if (sizeGuideFrame && !sizeGuideFrame.getAttribute('src')) {
        sizeGuideFrame.setAttribute('src', sizeGuideFrame.getAttribute('data-src'));
        /* failsafe: never trap the user behind the spinner if `load` misfires */
        setTimeout(hideSizeGuideLoader, 8000);
      }
      if (typeof sizeGuide.showModal === 'function') sizeGuide.showModal();
      else sizeGuide.setAttribute('open', '');
    });
  });
  if (sizeGuide) {
    $$('[data-size-guide-close]', sizeGuide).forEach(function (b) {
      b.addEventListener('click', function () { sizeGuide.close(); });
    });
    sizeGuide.addEventListener('click', function (e) {
      if (e.target === sizeGuide) sizeGuide.close();
    });
  }

  /* ------------------------------------------------------------------ *
   * Fit bridge — мост с калькулятором Find my size в iframe сайз-чарта.
   *
   * Чарт шлёт postMessage:
   *   viossi:fit          — размер посчитан → кэшируем в localStorage и
   *                         рисуем «Recommended: US 42» у ссылки Find your size
   *                         (только на PDP той же категории: размер пиджака
   *                         не равен размеру брюк).
   *   viossi:fit-comment  — клиент нажал «Add to order comment» → дописываем
   *                         размер и замеры отдельной строкой в cart note
   *                         (строка «Fit check …» заменяется, не дублируется),
   *                         отвечаем чарту ok/fail, чтобы кнопка показала итог.
   * Источник сообщений проверяется по origin iframe'а из data-src.
   * ------------------------------------------------------------------ */
  var FIT_KEY = 'viossi:fit';
  var fitRow = $('[data-fit-cat]');
  var fitChip = $('[data-fit-rec]');

  var sizeGuideOrigin = '';
  if (sizeGuideFrame) {
    try {
      sizeGuideOrigin = new URL(sizeGuideFrame.getAttribute('data-src'), window.location.href).origin;
    } catch (err) {
      sizeGuideOrigin = '';
    }
  }

  function readFit() {
    try {
      var raw = window.localStorage.getItem(FIT_KEY);
      var data = raw ? JSON.parse(raw) : null;
      return data && data.fit && data.fit.size ? data.fit : null;
    } catch (err) {
      return null;
    }
  }

  function renderFitChip() {
    if (!fitChip || !fitRow) return;
    var fit = readFit();
    var cat = fitRow.getAttribute('data-fit-cat');
    if (!fit || !cat || fit.category !== cat) {
      fitChip.hidden = true;
      return;
    }
    fitChip.textContent = '';
    fitChip.appendChild(document.createTextNode('Recommended: '));
    var b = document.createElement('b');
    b.textContent = fit.size + (fit.pants ? ' / ' + fit.pants : '');
    fitChip.appendChild(b);
    fitChip.hidden = false;
  }

  function fitNoteLine(fit) {
    var line = 'Fit check — size ' + fit.size;
    if (fit.pants) line += ' (pants ' + fit.pants + ')';
    if (fit.summary) line += ': ' + fit.summary;
    /* Ручной Fit preference убран из чарта (решение владельца 27.07) — вместо
       него в строку идёт только фактический крой товара из ?fit= iframe'а. */
    if (fit.productFit) line += ' · ' + fit.productFit + '-cut style';
    return line;
  }

  function appendFitToNote(fit, reply) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function (cart) {
        /* Идемпотентно: прошлую строку Fit check выкидываем, свежую дописываем. */
        var lines = String(cart.note || '')
          .split('\n')
          .filter(function (l) { return l.trim() && l.indexOf('Fit check') !== 0; });
        lines.push(fitNoteLine(fit));
        var note = lines.join('\n');
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note })
        }).then(function (r) {
          if (!r.ok) throw new Error('update');
          /* Комментарий живёт в мини-модалке (cart.js, initCartNotes) — тычок
             в её поля отдаём владельцу состояния событием, иначе он считает
             дописанную нами строку несохранённым черновиком и затрёт её. */
          document.dispatchEvent(new CustomEvent('cart:note-set', { detail: { note: note } }));
          reply('viossi:fit-comment-ok');
        });
      })
      .catch(function () {
        reply('viossi:fit-comment-fail');
      });
  }

  if (sizeGuideOrigin) {
    window.addEventListener('message', function (e) {
      if (e.origin !== sizeGuideOrigin) return;
      var data = e.data || {};
      if (data.type === 'viossi:fit' && data.fit && data.fit.size) {
        try {
          window.localStorage.setItem(FIT_KEY, JSON.stringify({ fit: data.fit, ts: Date.now() }));
        } catch (err) { /* приватный режим — чип просто не переживёт страницу */ }
        renderFitChip();
      } else if (data.type === 'viossi:fit-comment' && data.fit && data.fit.size) {
        appendFitToNote(data.fit, function (type) {
          if (e.source && e.source.postMessage) e.source.postMessage({ type: type }, e.origin);
        });
      }
    });
  }

  renderFitChip();

  /* ------------------------------------------------------------------ *
   * Sticky add-to-cart bar
   * ------------------------------------------------------------------ */
  var sticky = $('#pdpSticky');
  var stickySelect = $('#pdpStickySelect');
  if (sticky && atcBtn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0, rootMargin: '0px' });
    io.observe(atcBtn);
  }
  if (stickySelect && select) {
    stickySelect.addEventListener('change', function () {
      select.value = stickySelect.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  var stickyAdd = $('#pdpStickyAdd');
  if (stickyAdd && form) {
    stickyAdd.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ------------------------------------------------------------------ *
   * AJAX add-to-cart -> notify the drawer via `cart:updated`
   * ------------------------------------------------------------------ */
  var atcInFlight = false;

  function setBusy(busy) {
    atcInFlight = busy;
    if (!atcBtn) return;
    atcBtn.classList.toggle('is-busy', busy);
    atcBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function showError(msg) {
    var box = $('#pdpFormError');
    if (!box) return;
    box.textContent = msg;
    box.hidden = !msg;
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // no-JS-equivalent fallback: native submit
      var opt = selectedOption();
      if (select && (!opt || opt.value === '')) {
        e.preventDefault();
        showError(form.getAttribute('data-choose-size') || 'Please choose a size.');
        if (dd && !dd.hidden) { dd.classList.add('open'); }
        else if (select) select.focus();
        return;
      }
      if (opt && opt.getAttribute('data-available') !== 'true') { e.preventDefault(); return; }

      e.preventDefault();
      /* pointer-events прикрывает только мышь — Enter с клавиатуры без
         этого гарда отправлял форму трижды и клал дубли в корзину */
      if (atcInFlight) return;
      showError('');
      setBusy(true);

      var timeoutSig = (typeof AbortSignal !== 'undefined' && AbortSignal.timeout)
        ? AbortSignal.timeout(15000)
        : undefined;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
        signal: timeoutSig
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) {
            var err = new Error(d.description || d.message || '');
            err.userFacing = !!(d.description || d.message);
            throw err;
          });
          return r.json();
        })
        .then(function () {
          /* Товар уже в корзине — сбой рефреша дальше не должен выглядеть
             отказом (покупатель кликает ещё раз → дубли). Фолбэк: просто
             открываем drawer, его серверная разметка догонит состояние. */
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) {
              if (!r.ok) throw new Error('cart.js ' + r.status);
              return r.json();
            })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            })
            .catch(function () {
              document.dispatchEvent(new CustomEvent('cart:open'));
            });
        })
        .catch(function (err) {
          /* Сырые TypeError/SyntaxError покупателю не показываем */
          var msg = (err && err.userFacing && err.message) ||
            form.getAttribute('data-error-generic') ||
            'Something went wrong. Please try again.';
          showError(msg);
        })
        .finally(function () { setBusy(false); });
    });
  }

  /* ------------------------------------------------------------------ *
   * Accordions — smooth expand/collapse on the native <details>
   * ------------------------------------------------------------------ */
  var accWrap = $('.pdp-acc');
  if (accWrap) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    accWrap.classList.add('acc-enhanced');
    $$('.acc-item', accWrap).forEach(function (item) {
      var summary = item.querySelector('.acc-q');
      var panel = item.querySelector('.acc-a');
      if (!summary || !panel) return;

      // Items that start open must not be trapped behind max-height: 0.
      if (item.open) panel.style.maxHeight = 'none';

      function openPanel() {
        item.open = true;
        if (reduceMotion) { panel.style.maxHeight = 'none'; return; }
        panel.style.maxHeight = '0px';
        // force reflow so the transition runs from 0
        void panel.offsetHeight;
        panel.style.maxHeight = panel.scrollHeight + 'px';
        var done = function () {
          panel.style.maxHeight = 'none';
          panel.removeEventListener('transitionend', done);
        };
        panel.addEventListener('transitionend', done);
      }

      function closePanel() {
        if (reduceMotion) { item.open = false; panel.style.maxHeight = ''; return; }
        panel.style.maxHeight = panel.scrollHeight + 'px';
        void panel.offsetHeight;
        panel.style.maxHeight = '0px';
        var done = function () {
          item.open = false;
          panel.style.maxHeight = '';
          panel.removeEventListener('transitionend', done);
        };
        panel.addEventListener('transitionend', done);
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.open) closePanel(); else openPanel();
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Honest urgency line
   *   • "Only N left in SIZE"  — from real, tracked inventory (Liquid JSON)
   *   • "N people have this in their bag" — live add-to-cart counter
   * Any part is shown only when its data is real; otherwise it is omitted.
   * ------------------------------------------------------------------ */
  var urgencyEl = $('#pdpUrgency');
  var urgencyTextEl = $('#pdpUrgencyText');
  var lowStock = null;
  var bagCount = null;

  if (urgencyEl && urgencyTextEl) {
    var dataScript = urgencyEl.querySelector('[data-pdp-low-stock]');
    if (dataScript) {
      try { lowStock = JSON.parse(dataScript.textContent || '{}'); } catch (err) { lowStock = null; }
    }

    // Live social-proof counter — fully optional, fails silently.
    var productId = urgencyEl.getAttribute('data-product-id');
    if (window.fetch && productId) {
      fetch('https://api.viossi.tech/social-proof?product_id=' + encodeURIComponent(productId), {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && typeof data.atc_48h === 'number') {
            bagCount = data.atc_48h;
            renderUrgency(currentUrgencyVariant);
          }
        })
        .catch(function () { /* endpoint down — just skip the bag line */ });
    }
  }

  var currentUrgencyVariant = '';

  function fillTemplate(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, key) {
      return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : m;
    });
  }

  function renderUrgency(variantId) {
    if (!urgencyEl || !urgencyTextEl) return;
    currentUrgencyVariant = variantId || '';

    var parts = [];
    var lead = urgencyEl.getAttribute('data-lead') || '';

    // Low-stock part — only if this exact variant is tracked and low.
    if (lowStock && lowStock.variants && variantId && lowStock.variants[variantId]) {
      var entry = lowStock.variants[variantId];
      var lowTpl = urgencyEl.getAttribute('data-low-template') || 'Only {count} left in {size}';
      parts.push('<b>' + escapeHtml(fillTemplate(lowTpl, { count: entry.qty, size: entry.label })) + '</b>');
    }

    // Social-proof part — only when the live count clears the minimum.
    // Не вместе с low-stock: «Only 1 left — 17 people have this in their bag»
    // читается как выдуманная срочность, хотя оба факта живые.
    var bagMin = parseInt(urgencyEl.getAttribute('data-bag-min'), 10) || 3;
    if (!parts.length && bagCount !== null && bagCount >= bagMin) {
      var bagTpl = urgencyEl.getAttribute('data-bag-template') || '{count} people have this in their bag right now';
      parts.push(escapeHtml(fillTemplate(bagTpl, { count: bagCount })));
    }

    if (!parts.length) {
      urgencyEl.hidden = true;
      urgencyTextEl.textContent = '';
      return;
    }

    var html = '';
    if (lead) html += '<b>' + escapeHtml(lead) + '</b> ';
    html += parts.join(' — ');
    urgencyTextEl.innerHTML = html;
    urgencyEl.hidden = false;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // Initialise state on load.
  syncVariantState();
})();
